<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div>
                <header>
                    <v-card-title> Bitácora </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div> 
            <div class="content_accion" >
                <v-expansion-panels v-model="panel">
                    <v-expansion-panel>
                        <v-expansion-panel-title>Filtros</v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <div class="override_content_flex mt-4">
                                <div class="col-flex-3">
                                    <v-text-field 
                                        type="date" 
                                        variant="outlined"
                                        label="Fecha Inicio" 
                                        v-model="formGroup.data.fecha_inicial"
                                        :rules="formGroup.rules.fecha_inicial"                                        
                                    ></v-text-field>
                                </div>
                                <div class="col-flex-3">
                                    <v-text-field 
                                        type="date" 
                                        variant="outlined"
                                        label="Fecha Fin" 
                                        :min="fecha_inicial"
                                        :max="validateMaxDate()"
                                        v-model="formGroup.data.fecha_final"
                                        :rules="formGroup.rules.fecha_final"                                       
                                    ></v-text-field>
                                </div>
                                <div class="col-flex-3" >
                                    <v-autocomplete
                                        v-model="formGroup.data.id_modulo"
                                        label="Modulos"
                                        variant="outlined"
                                        :items="arrModList"
                                        item-title="nombre"
                                        item-value="id_modulo"
                                        prepend-inner-icon="mdi-magnify"                                        
                                    ></v-autocomplete>
                                </div>
                                 <div class="col-flex-3" >
                                    <v-select
                                        v-model="formGroup.data.usuario"                                        
                                        label="Usuarios"
                                        variant="outlined"
                                        :items="arrUsers"                                       
                                        item-title="nombre"
                                        item-value="username"
                                        prepend-inner-icon="mdi-magnify"                                        
                                    ></v-select>
                                </div>
                                <div class="col-flex-12 actions_buttons">
                                    <v-btn
                                        color="indigo-darken-3"
                                        style="margin-top: 5px; margin-right: 2px;"                                        
                                        :disabled="validateFilter()"
                                        @click="exportToExcel()"
                                    >
                                        <v-tooltip activator="parent" location="top">Exportar Datos</v-tooltip>
                                        <v-icon>mdi-file-table</v-icon>
                                    </v-btn>
                                    <v-btn
                                        color="indigo-darken-3"
                                        style="margin-top: 5px;"
                                        prepend-icon="mdi-plus"
                                        text="Buscar"
                                        :disabled="validateFilter()"                                        
                                        @click="getBitacoras()"
                                    ></v-btn>

                                    <v-btn
                                        color="indigo-darken-3"
                                        style="margin-top: 5px; margin-left: 2px;"
                                        prepend-icon="mdi-trash-can"
                                        text="Limpiar"                                        
                                        @click="limpiarCampos()"
                                    ></v-btn>
                                </div>
                              
                            </div>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <div class="container_table">
                <v-data-table
                class="content_table"
                :headers="headersTable"
                fixed-header
                :items="listBitacoras"                
                :loading="loading"
                >         
                </v-data-table>
            </div>
        </v-card>
        <SnackbarComponent :value="snackbarData"/>
        <AlertComponent :value="dialogData" />
    </div>
</template>

<script>
import SnackbarComponent from '@/components/Snackbar.vue'
import {BitacoraService} from '@/services/BitacoraService.js'
import AlertComponent from "@/components/Alert.vue";
import { utils, writeFile } from 'xlsx'


export default {
    name: 'BitacoraComponent',
    components: {
        SnackbarComponent,
        AlertComponent      
    },
    data() {
        return{
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dialogData: {
                openDialog: false,
                title: "",
                description: "",
                icon: "",
            },
            arrModList:[
                'Aviso','Carrusel','Base de Datos','Documentación','Despacho','Dirección','Gestión',
                'Metas','PDF','Reportes','Teléfono','Minuta','Grupos','Usuarios', 'Login - Logout',
            ],
            arrUsers:[],            
            listBitacoras:[],
            loading:false,
            headersTable:[
                { title: "Usuario", key: "usuario" },
                { title: "Acción", key: "tipo_accion" },
                { title: "Tabla", key: "tablas" },
                { title: "Módulo", key: "modulo" },
                { title: "IP", key: "ip_origen" },
                { title: "Fecha Creación", key: "created_at" },
            ],
            panel: [],
            formGroup:{
                data:{
                    fecha_inicial: null,
                    fecha_final:null,
                    id_modulo:null,
                    usuario:null,
                },
                rules: {
                    fecha_inicial: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                    fecha_final: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                
                }
            
            }
        }
    },
    beforeMount() {
        this.getUsers();
    },
    methods:{
        validateMaxDate: function () {
            let FECHA_INICIAL = this.formGroup.data.fecha_inicial
            if (FECHA_INICIAL === null) {
                return;
            }
            let arrDateInit = FECHA_INICIAL.split('-')
            let dateInitial = new Date(parseInt(arrDateInit[0]), parseInt(arrDateInit[1]) - 1, arrDateInit[2])

            dateInitial.setDate(dateInitial.getDate() + 32);

            let year = dateInitial.getFullYear();
            let month = (dateInitial.getMonth()+1 < 10) ? `0${dateInitial.getMonth()+1}` : dateInitial.getMonth()+1
            let date = (dateInitial.getDate() < 10) ? `0${dateInitial.getDate()}` : dateInitial.getDate()
            let strMaxDate = `${year}-${month}-${date}`
            return strMaxDate;
        },
        validateFilter(){
            const FECHA_INICIAL = this.formGroup.data.fecha_inicial
            if (FECHA_INICIAL === null || FECHA_INICIAL === undefined || FECHA_INICIAL === '') {
                return true
            }
            const FECHA_FINAL = this.formGroup.data.fecha_final
            if (FECHA_FINAL === null || FECHA_FINAL === undefined || FECHA_FINAL === '') {
                return true
            }
            
            return false
        },
        getBitacoras: async function(){
            this.loading = true;           
            let start_date = this.formGroup.data.fecha_inicial
            let end_date = this.formGroup.data.fecha_final
            let modulo = this.formGroup.data.id_modulo
            let user = this.formGroup.data.usuario

            if(start_date === null){
                start_date = await BitacoraService.encriptar('NA');
            }else{
                start_date = await BitacoraService.encriptar(this.formGroup.data.fecha_inicial)
            }

            if( end_date === null){
                end_date = await BitacoraService.encriptar('NA');
            }else{
                end_date = await BitacoraService.encriptar(this.formGroup.data.fecha_final)
            }

            if(modulo === null){
                modulo = await BitacoraService.encriptar('NA');
            }else{
                modulo = await BitacoraService.encriptar(this.formGroup.data.id_modulo)
            }

            if(user === null){
                user = await BitacoraService.encriptar('NA');
            }else{
                user = await BitacoraService.encriptar(this.formGroup.data.usuario)
            }
            
            await BitacoraService.getBitacoras(start_date.msg, end_date.msg,modulo.msg, user.msg).then((resp)=>{
                if(!resp.error){
                    this.listBitacoras = resp.response
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                }else{
                    this.dialogData = {
                        openDialog: true,
                        title: "Ocurrió un Problema",
                        description: resp.msg,
                    };
                }
            }).catch((err)=>{
                console.log("ERROR: getBitacoras: ", err);
            });
            this.panel = false;
        },
        getUsers: async function(){
            
            await BitacoraService.getUsers().then((resp) =>{
                if(!resp.error){
                    this.arrUsers = resp.response;
                    this.arrUsers.forEach(e =>{
                        e.nombre = `${e.name} ${e.last_name}`
                    })
                }else{
                    this.dialogData = {
                        openDialog: true,
                        title: "Ocurrió un Problema",
                        description: resp.msg,
                    };
                }
            }).catch((err)=>{
                console.log("ERROR: getUsers: ", err);
            })
        },
        limpiarCampos(){
            this.formGroup.data.fecha_inicial = null
            this.formGroup.data.fecha_final = null
            this.formGroup.data.id_modulo = null
            this.formGroup.data.usuario = null 
            this.listBitacoras = []
        },
        exportToExcel: function(){
            const columns = [
                { key: 'usuario', label: 'Usuario' },
                { key: 'tipo_accion', label: 'Acción' },
                { key: 'tablas', label: 'Tabla' },
                { key: 'modulo', label: 'Módulo' },
                { key: 'ip_origen', label: 'IP' },
                { key: 'created_at', label: 'Fecha Creación' },
                { key: 'mensaje', label: 'Comentario' }
            ]

            // Convierte a hoja
            const ws = utils.json_to_sheet(
                this.listBitacoras.map(r => Object.fromEntries(columns.map(c => [c.label, r[c.key]])))
            )

            // Auto-ancho básico
            const colWidths = columns.map(c => ({
                wch: Math.max(
                c.label.length,
                ...this.listBitacoras.map(r => String(r[c.key] ?? '').length)
                ) + 2
            }))
            ws['!cols'] = colWidths

            // Nombre del archivo
            //let date = new Date();
            //let nombreFile  = `bitacora-${date.getDay()}-${date.getMonth()+1}-${date.getFullYear()}.xlsx`;
            // Libro y descarga
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, 'Bitacora')
            writeFile(wb, 'bitacora.xlsx')
        }        
    }
}
</script>

<style>

</style>